import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import CheckableInput from 'components/CheckableInput';
import { setStorage } from 'utilz';
import { URLS } from 'config';

import Error from './components/Error';
import containerActions from './actions';

export const monthlyData = {
  1000: '$1000',
  1500: '$1500',
  2000: '$2000',
  3000: '$3000',
  '-1': 'I can\'t give a down payment'
};

class MounthlyPage extends React.Component {
  state = { error: false }

  onCloseHandl = () => {
    this.setState({ error: false }, () => {
      // this.props.history.push(URLS.SEARCH);
    });
  }

  selectDownPaymentHandl = (e) => {
    this.props.downChangeHandl(e.target.value);
  }

  sendData = isDownPayment => () => {
    if (isDownPayment) {
      if (this.props.down === '-1') {
        this.setState({ error: true });
      }
    }

    this.props.mounthlySend(() => {
      if (this.props.mounthly >= 0 && this.props.down >= 0) {
        this.props.history.push(URLS[isDownPayment ? 'APPROVED' : 'CONFIRMATION']);
      }

      setStorage({
        mounthly: {
          mounthly: this.props.mounthly,
          down: this.props.down
        }
      });
    }, isDownPayment);
  }

  renderChanse = isDownPayment => (
    <React.Fragment>
      <PageTitle>
        What down payment you have <span>available?</span>
      </PageTitle>
      <div className="mounthly-list">
        {
          Object.keys(monthlyData).map((el, index) => index || !index ? (
            <CheckableInput
              name="mounthly"
              changeHandl={this.selectDownPaymentHandl}
              value={el}
              key={el}
              checked={this.props.down === el}
            >
              {monthlyData[el]}
            </CheckableInput>
          ) : null)
        }
      </div>
      <Button
        onClick={this.sendData(isDownPayment)}
        disabled={typeof this.props.down === 'boolean'}
      >
          Check my сhances
      </Button>
    </React.Fragment>
  )

  render() {
    return (
      <div className="page-mounthly">
        { this.renderChanse(true) }
        { this.state.error ? <Error close={this.onCloseHandl} /> : null }
      </div>
    );
  }
}

MounthlyPage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  mounthly: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  down: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  mounthlySend: PropTypes.func.isRequired,
  downChangeHandl: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  working: state.working.working,
  mounthly: state.mounthly.mounthly,
  down: state.mounthly.down
});

export default connect(mapStateToProps, containerActions)(MounthlyPage);



// WEBPACK FOOTER //
// ./src/pages/Mounthly/Down.js